import { render, staticRenderFns } from "./ApproveListSetting.vue?vue&type=template&id=ec4f434c&scoped=true"
import script from "./ApproveListSetting.vue?vue&type=script&lang=js"
export * from "./ApproveListSetting.vue?vue&type=script&lang=js"
import style0 from "./ApproveListSetting.vue?vue&type=style&index=0&id=ec4f434c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4f434c",
  null
  
)

export default component.exports